import React, { useState, useEffect } from "react";
import { Table, Modal, Button , Radio  } from "antd";
import Api from "../../../../../services/ServiceApi";
import moment from "moment";
const AdvertisingScheduleTable = ({adsData}) => {
  const [visibleModal, setVisibleModal] = useState(false);

  const Artwork = () => {
    // console.log("reach artwork component");
    return (
      <Modal
        title="Artwork"
        visible={visibleModal}
        onCancel={() => setVisibleModal(false)}
        width={625}
        footer={[
          <div className="text-center">
            <Button
              key="back"
              type="default"
              className="cancelButton"
              onClick={() => setVisibleModal(false)}
            >
              Close
            </Button>
          </div>,
        ]}
      >
        <div
          style={{
            borderStyle: "solid",
            borderColor: "#f0f1f1",
            height: "325px",
            margin: "1vh 2.5vw",
            borderWidth: "3px",
          }}
        >
          <div className="d-flex align-items-center">
            <img
              style={{
                "object-fit": "cover",
                width: "90px",
                height: "90px",
                margin: "10px",
              }}
              src={Api.absoluteUrl("/img/img_job.png")}
              alt="image for artwork"
            ></img>
            <img
              style={{
                "object-fit": "cover",
                width: "90px",
                height: "90px",
                margin: "10px",
              }}
              src={Api.absoluteUrl("/img/img_job.png")}
              alt="image for artwork"
            ></img>
          </div>
        </div>
      </Modal>
    );
  };
  const columns = [
    {
      title: "Advertising area",
      children: [
        {
          title: "Advertise Name",
          dataIndex: "advertise_name",
          key: "advertise_name",
          render: (item) => (
            item === null ?  "-" : item
          )
        },
        {
          title: "External  - FW",
          dataIndex: "fw",
          key: "fw",
          render: (item) => (
            <Radio checked={
              item === null || item === 0 ? false : 
              true}></Radio>
          )
        },
        {
          title: "External - HW",
          dataIndex: "hw",
          key: "hw",
          render: (item) => (
            <Radio checked={
              item === null || item === 0 ? false : 
              true}></Radio>
          )
        },
        {
          title: "External - QW",
          dataIndex: "qw",
          key: "qw",
          render: (item) => (
            <Radio checked={
              item === null || item === 0 ? false : 
              true}></Radio>
          )
        },

        {
          title: "Internal In Bus",
          dataIndex: "ib",
          key: "ib",
          render: (item) => (
            <Radio checked={
              item === null || item === 0 ? false : 
              true}></Radio>
          )
        },
        {
          title: "Internal - Hangar",
          dataIndex: "hg",
          key: "hg",
          render: (item) => (
            <Radio checked={
              item === null || item === 0 ? false : 
              true}></Radio>
          )
        },
        {
          title: "Internal - LCD",
          dataIndex: "lcd",
          key: "lcd",
          render: (item) => (
            <Radio checked={
              item === null || item === 0 ? false : 
              true}></Radio>
          )
        },
      ],
    },
    // External date
    {
      title: "External Date",
      children: [
        {
          title: "Start Date",
          dataIndex: "booking_external_date",
          key: "booking_external_date",
          render: (item) => (
            item === null ?  "-" :
            moment(item).format("DD/MM/YYYY HH:mm")
          )
        },
        {
          title: "Expired Date",
          dataIndex: "booking_external_date_end",
          key: "booking_external_date_end",
          render: (item) => (
            item === null ?  "-" :   moment(item).format("DD/MM/YYYY HH:mm")
          )
        },
      ],
    },
    // Internal date
    {
      title: "Internal Date",
      children: [
        {
          title: "Start Date",
          dataIndex: "booking_internal_date",
          key: "booking_internal_date",
          render: (item) => (
            item === null ?  "-" :   moment(item).format("DD/MM/YYYY HH:mm")
          )
        },
        {
          title: "Expired Date",
          dataIndex: "booking_internal_date_end",
          key: "booking_internal_date_end",
          render: (item) => (
            item === null ?  "-" :   moment(item).format("DD/MM/YYYY HH:mm")
          )
        },
        // {
        //   title: "Artwork",
        //   dataIndex: "isArtwork",
        //   key: "isArtwork",
        //   render: (item) => {
        //     if (item) {
        //       return (
        //         <button
        //           onClick={() => {
        //             console.log("it is clicked");
        //             setVisibleModal(true);
        //           }}
        //         >
        //           <img
        //             src={Api.absoluteUrl("/icon/view.svg")}
        //             alt="view icon"
        //           />
        //         </button>
        //       );
        //     } else {
        //       return (
        //         <button onClick={() => console.log("not view is Click")}>
        //           <img
        //             src={Api.absoluteUrl("/icon/not_view.svg")}
        //             alt="not view icon"
        //           />
        //         </button>
        //       );
        //     }
        //   },
        // },
      ],
    },
  ];
  return (
    <React.Fragment>
      <Table dataSource={adsData} columns={columns} style={{ width: "100%" }} />
      <Artwork />
    </React.Fragment>
  );
};

export default AdvertisingScheduleTable;
